import { useState, useEffect } from 'react';

export default function useIsHeaderPinned() {
  const [pinned, setPinned] = useState(true);

  useEffect(() => {
    const pin = () => setPinned(true);
    const unpin = () => setPinned(false);

    window.addEventListener('header.pin', pin);
    window.addEventListener('header.unpin', unpin);

    return () => {
      window.removeEventListener('header.pin', pin);
      window.removeEventListener('header.unpin', unpin);
    };
  }, []);

  return pinned;
}
